import React, { useEffect, useState } from 'react';
import useStyles from './styles';
import _ from 'lodash';
import {/* Tabs as AntTabs, Tab as AntTab,  */Typography} from '@material-ui/core'
import { AntTabs, AntTab } from './AntTabs';
import TabPanel from './TabPanel';
import {withTheme} from "styled-components"

const Tabs = (props) => {

    const {isLoading = false, loadingContent = null, isDisplayNilWhenEmpty = false, emptyContentDisplay = null, isRenderAllInitially=false} = props;

    const classes = useStyles(props?.theme);
    const [isRendered, setIsRendered] = useState(false);

    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(()=>{
        setIsRendered(true);
    }, [])

    return (
        <div className={classes.wrapper}>
            <div className={classes.container}>
                <AntTabs scrollButtons="auto" variant="scrollable" value={value} onChange={handleChange} style={{height: 48}} classes={{indicator: classes.tabIndicator}} aria-label="ant example">
                    {
                        props?.tabs?.map((tab, idx) => <AntTab key={`tab_${idx}`} classes={{root: classes.tabRoot}} label={<span className={classes.tabLabelSpanContainer}><Typography variant='body1'>{tab?.title}</Typography><Typography variant='body2'>{tab?.subTitle}</Typography></span>} />)
                    }
                </AntTabs>
                <div className={classes.tabPanel}>
                    {
                        isLoading 
                            ?   loadingContent 
                            :   _.isEmpty(props?.tabs[value]?.content) && isDisplayNilWhenEmpty
                                ?   emptyContentDisplay
                                :   isRenderAllInitially && !isRendered ? props?.tabs.map(x => x.content || null) :(props?.tabs[value]?.content || null)
                    }
                </div>
            </div>
        </div>
    )
}

export default withTheme(Tabs);